import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FaFolderOpen, FaClock, FaArrowRight } from 'react-icons/fa';
import { blogData } from '../data/blogData';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './BlogSlider.css';

const BlogSlider = () => {
  return (
    <section className="blog-slider-section">
      <div className="container">
        
        <div className="section-header">
          <h5>DERNIÈRES MISES À JOUR</h5>
          <h2>NOTRE <span>BLOG</span></h2>
        </div>

        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          navigation={true}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          className="blog-swiper"
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {blogData.map((post) => (
            <SwiperSlide key={post.id}>
              <div className="blog-card">
                
                {/* Image (Sans Overlay bouton maintenant) */}
                <div className="blog-img-box">
                  <img src={post.image} alt={post.title} />
                  {/* On a retiré le bouton qui était ici */}
                </div>

                <div className="blog-meta">
                   <span className="meta-item">
                     <FaClock /> {post.date}
                   </span>
                   <span className="meta-item">
                     <FaFolderOpen /> {post.category}
                   </span>
                </div>

                <div className="blog-info">
                  <h3>
                    <Link to={`/blog/${post.id}`}>{post.title}</Link>
                  </h3>
                  
                  {/* Le texte remplit l'espace */}
                  <p>{post.excerpt}</p>
                  
                  {/* Le bouton "Lire la suite" est maintenant ici, après le texte */}
                  <Link to={`/blog/${post.id}`} className="read-more-inline">
                    Lire la suite <FaArrowRight />
                  </Link>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
};

export default BlogSlider;